import { blockCategories } from '../../../categories';
import { DialogService } from 'aurelia-dialog';
import { Container } from 'aurelia-framework';
import { UniversalEntitySelect } from '../../../../../../dialog/universal-entity-select';

const dialogService = Container.instance.get(DialogService);

function getVideoSrc(item) {
    if (!item?.file) return null;
    return (
        item.file.downloadUrl ||
        (item.file.previewUrl
            ? item.file.previewUrl
                  .replace('$width', '1500')
                  .replace('$height', '-')
            : null)
    );
}

function openVideoMediaSelector(component) {
    dialogService
        .open({
            viewModel: UniversalEntitySelect,
            model: {
                selectModelId: 'media-database/media-item',
                conditions: { type: { $in: ['video'] } },
            },
        })
        .whenClosed((data) => {
            const items = data.output;
            if (!items || items.length === 0) return;
            const src = getVideoSrc(items[0]);
            if (src && component) {
                component.addAttributes({ src });
                component.trigger('change:attributes');
            }
        });
}

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    editor.TraitManager.addType('media-video-select', {
        noLabel: true,
        createInput({ trait }) {
            const wrapper = document.createElement('div');
            const button = document.createElement('button');
            button.innerText = 'Aus Medienbibliothek wählen';
            button.className = 'gjs-btn-prim';
            button.style.cssText =
                'width:100%;margin-top:6px;padding:6px 10px;cursor:pointer;';
            button.addEventListener('click', (e) => {
                e.preventDefault();
                openVideoMediaSelector(trait.target);
            });
            wrapper.appendChild(button);
            return wrapper;
        },
        onEvent() {},
        onUpdate() {},
    });

    blockManager.add('bs-video', {
        label: 'Video',
        category: blockCategories.basic,
        content: {
            type: 'bs-video',
        },
        media: `<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="youtube" class="svg-inline--fa fa-youtube fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg>`,
    });

    const type = 'bs-embed-responsive';

    domComponents.addType(type, {
        model: {
            defaults: {
                'custom-name': 'Video',
                tagName: 'video',
                droppable: false,
                draggable: false,
                copyable: false,
                resizable: 1,
                classes: ['sio-video', 'embed-responsive-item' ],
                attributes: {
                    src: "",
                    controls: true,
                },
                traits: [
                    {
                        type: 'media-video-select',
                        name: 'media-select',
                    },
                    {
                        type: 'text',
                        name: 'src',
                        label: 'Source URL',
                        placeholder: 'https://example.com/video.mp4',
                    },
                    {
                        type: 'checkbox',
                        name: 'controls',
                        label: 'Show Controls',
                    },
                    {
                        type: 'checkbox',
                        name: 'autoplay',
                        label: 'Autoplay',
                    },
                    {
                        type: 'checkbox',
                        name: 'loop',
                        label: 'Loop',
                    },
                    {
                        type: 'checkbox',
                        name: 'muted',
                        label: 'Muted',
                    },
                    {
                        type: 'text',
                        name: 'poster',
                        label: 'Poster Image URL',
                        placeholder: 'https://example.com/poster.jpg',
                    },
                    {
                        type: 'size-with-unit',
                        label: false,
                        name: 'width',
                        property: 'width',
                        displayLabel: 'Breite',
                    },
                    {
                        type: 'size-with-unit',
                        label: false,
                        name: 'height',
                        property: 'height',
                        displayLabel: 'Höhe',
                    },
                ],
            },
        },
        isComponent: function (el) {
            if (
                el &&
                el.tagName === 'VIDEO' &&
                el.className &&
                el.className.includes('embed-responsive-item')
            ) {
                return { type: type };
            }
        },
        view: {
            events: {
                dblclick: 'openVideoMediaLibrary',
            },
            openVideoMediaLibrary(e) {
                e?.stopPropagation?.();
                openVideoMediaSelector(this.model);
            },
        },
    });
};
